module.exports = __webpack_public_path__ + "img/focused.a3ede3f2.gif";